/** „Meine Firmen" — eigene Betriebe für die Kontakt-Zuordnung (crm_kontakte.firma_zuordnung). */
export interface MeineFirma { value: string; label: string; }

export const MEINE_FIRMEN: MeineFirma[] = [
  { value: 'gutachten', label: 'SV Büro' },
  { value: 'mietwagen', label: 'LCS' },
  { value: 'autoglas', label: 'Autoglas' },
  { value: 'werkstatt', label: 'Werkstatt' },
  { value: 'unfallgiganten', label: 'Unfallgiganten' },
];

export function meineFirmaLabel(value: string | null | undefined): string {
  if (!value) return '';
  return MEINE_FIRMEN.find((f) => f.value === value)?.label ?? value;
}

/** Kontakttypen (crm_kontakte.kategorie). */
export interface KontaktTyp { value: string; label: string; }

export const KONTAKT_TYPEN: KontaktTyp[] = [
  { value: 'kontakt', label: 'Kontakt' },
  { value: 'auftraggeber', label: 'Auftraggeber' },
  { value: 'versicherung', label: 'Versicherung' },
  { value: 'anwalt', label: 'Anwalt / Kanzlei' },
  { value: 'werkstatt', label: 'Werkstatt' },
  { value: 'haendler', label: 'Händler' },
  { value: 'betrieb', label: 'Betrieb' },
  { value: 'behoerde', label: 'Behörde' },
  { value: 'sonstige', label: 'Sonstige' },
];
